<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-06-28 20:13:34
 * @最后编辑: Betway
 * @最后修改时间: 2023-06-08 11:17:50
-->
<template>
  <div>
    <!-- :hideAddBtn="!hasBtn('add-staff')" -->
    <!-- <v-btn @click="download">
      批量下载
    </v-btn> -->
    <mrc_ess_table
      v-if="$route.name == 'staffmanagement'"
      :headers="headers"
      :paginationOptions="options"
      :hideAddBtn="true"
      @turnPage="getlist"
      :slotKey="['name', 'STATUS', 'dept_uuid', 'staff_status']"
      :isLoading="loading"
      :items="desserts"
    >
      <template v-slot:btns>
        <mrc_ess_uploadBtn
          type="8"
          :hrefUrl="uploadUrl"
          class="ml-4"
          v-btnAuth="['import-staff-property']"
          :label="$t('label_Batch_Import')"
        ></mrc_ess_uploadBtn>
      </template>
      <template v-slot:search>
        <v-row
          class="d-flex justify-end"
          style="
            background: white;
            margin: 0;
            border-top-right-radius: 8px;
            border-top-left-radius: 8px;
            padding: 0 16px;
          "
        >
          <mrc_ess_advanceFilterAndSearchInput
            class="mt-4"
            v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1, pagesize: $store.state.pageSize })"
            :systemFieldMeta="systemFieldMeta"
          ></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <!-- 岗位职能 -->
      <template v-slot:item.name="{ item }">
        <div>
          <mrc_ess_staffListView :staffObj="item"></mrc_ess_staffListView>
        </div>
      </template>
      <template v-slot:item.dept_uuid="{ item }">
        <mrc_ess_prompt
          view
          :disabled="true"
          v-model="item.dept_uuid"
          :select_arr="unitArr"
        ></mrc_ess_prompt>
      </template>
      <!-- 状态 -->
      <template v-slot:item.STATUS="{ item }">
        <mrc_ess_chip
          rounded
          color="#13a671"
          text-color="white"
          small
          class="mr-1"
          v-if="item.STATUS == 1"
        >
          {{ $t("label_To_enable_the") }}
        </mrc_ess_chip>
        <mrc_ess_chip
          rounded
          color="#999999"
          text-color="white"
          small
          class="mr-1"
          v-if="item.STATUS == 0"
        >
          {{ $t("label_Frozen") }}
        </mrc_ess_chip>
      </template>
      <template v-slot:item.staff_status="{ item }">
        <!-- 在职 -->
        <mrc_ess_chip
          rounded
          color="#A3CFE4"
          text-color="text--primary"
          small
          class="mr-1"
          v-if="item.staff_status == 3"
        >
          {{ $t("label_Working") }}
        </mrc_ess_chip>
        <!-- 试用期 -->
        <mrc_ess_chip
          rounded
          color="#FFDCBB"
          text-color="text--primary"
          small
          class="mr-1"
          v-if="item.staff_status == 1"
        >
          {{ $t("label_Probation_period") }}
        </mrc_ess_chip>
        <!-- 准备转正 -->
        <mrc_ess_chip
          rounded
          color="#BFF1FC"
          text-color="text--primary"
          small
          class="mr-1"
          v-if="item.staff_status == 2"
        >
          {{ $t("label_Get_ready_to_turn_right") }}
        </mrc_ess_chip>
        <!-- 已经离职 -->
        <mrc_ess_chip
          rounded
          color="#E5C5A7"
          text-color="text--primary"
          small
          class="mr-1"
          v-if="item.staff_status == 6"
        >
          {{ $t("label_Retired") }}
        </mrc_ess_chip>
        <!-- 准备离职 -->
        <mrc_ess_chip
          rounded
          color="#DEE1B8"
          text-color="text--primary"
          small
          class="mr-1"
          v-if="item.staff_status == 5"
        >
          {{ $t("label_Prepare_to_leave") }}
        </mrc_ess_chip>
        <!-- 准备入职 -->
        <mrc_ess_chip
          rounded
          color="#FFE99A"
          text-color="text--primary"
          small
          class="mr-1"
          v-if="item.staff_status == 0"
        >
          {{ $t("label_Preparetojoin") }}
        </mrc_ess_chip>
        <!-- 退休 -->
        <mrc_ess_chip
          rounded
          color="#D5DAE8"
          text-color="text--primary"
          small
          class="mr-1"
          v-if="item.staff_status == 7"
        >
          {{ $t("label_Retired_office") }}
        </mrc_ess_chip>
        <mrc_ess_chip
          rounded
          color="#dfdfdf"
          text-color="text--primary"
          small
          class="mr-1"
          v-if="item.staff_status == 4"
        >
          {{ $t("label_Stop") }}
        </mrc_ess_chip>
      </template>
      <!-- 操作 -->
      <template v-slot:item.actions="{ item }">
        <menu-list
          :list="[
            {
              name: $t('label_View'),
              show: hasBtn('view-staff-management'),
              type: 'view',
            },
            {
              name: $t('label_Edit'),
              show: hasBtn('edit-staff-management'),
              type: 'edit',
            },
            {
              name: $t('label_To_edit_your_password'),
              show: hasBtn('edit-staff-password'),
              type: 'edit-pw',
            },
            {
              name: $t('label_To_reset_your_password'),
              show: hasBtn('reset-staff-password'),
              type: 'reset',
            },
            {
              name: $t('label_Frozen_account'),
              show: hasBtn('edit-staff-status'),
              type: 'freeze',
            },
            {
              name: $t('label_staffMsg_m_resumePost'),
              show: item.staff_status == 6 ? hasBtn('resume-post') : false,
              type: 'resumePost',
            },
          ]"
          @handleClick="handleClick($event, item)"
        >
          <template v-slot:showAction>
            <v-icon
              v-btnAuth="[
                'view-staff-management',
                'edit-staff-management',
                'reset-staff-password',
                'edit-staff-password',
                'edit-staff-status',
                'resume-post',
              ]"
            >
              mdi-dots-vertical
            </v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>

    <router-view v-else></router-view>
    <changePassword ref="changePassword" />
  </div>
</template>

<script>
import { getBusinessList } from "@/service/api/prompt.js";
import { getStaffListForFilter } from "@/service/api/autoComplete.js";
import { validationMixin } from "vuelidate";
// import { required, maxLength, email } from 'vuelidate/lib/validators'
import { required, maxLength, between, email, url } from "vuelidate/lib/validators";
import {
  getStaffMsgList,
  freezeStaff,
  resetPassWord,
  resumePost,
} from "@/service/api/staffmsg.js";
import { findSrc } from "@/service/api/upload.js";
import { STAFF_PROPERTY_URL } from "@/utils/constant/index.js";
export default {
  components: {
    changePassword: () => import("./changePassword.vue"),
  },
  props: {},
  data() {
    return {
      // urlarr: "85e92dce-d314-4002-bffd-5f9b13c8c321",
      urlarr:
        "85e92dce-d314-4002-bffd-5f9b13c8c321,d0cfad70-287e-46eb-8862-aab18eb444cf,0cabb6b5-78ac-4ae1-a068-a9cdedbd6530",
      loading: false,
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      desserts: [],
      unitArr: [],
      allList: [],

      systemFieldMeta: [],
      systemSeniorQueryString: [],
      field_alias_name: null,
      table_alias_name: null,
      uploadUrl: "",
    };
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1);
  },
  async created() {
    await this.getBtnPermissionList();
    const res = await getBusinessList({
      prompt_name: "unit",
    });
    if (res.code == 200) {
      this.unitArr = res.data;
    }
  },
  async mounted() {
    this.loading = true;
    this.uploadUrl = STAFF_PROPERTY_URL;
    // await this.getdropDownList()
    await this.getlist();
    this.loading = false;
  },
  beforeDestroy() {
    this.$ls.remove("staffList");
    this.$store.commit("set_detailuuid", ""); //暂用用客户详情的detailuuid,暂时无bug
  },
  methods: {
    download() {
      findSrc({ uuid: this.urlarr }).then((res) => {
        this.$batchDownload(res.data.files);
      });
    },
    async getdropDownList() {
      const res = await getStaffListForFilter({
        org_level_uuid: this.$store.state.currentCompany,
      });
      if (res.code == 200) {
        this.allList = res.data;
      }
    },
    async getlist(obj) {
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--;
      const currentCompany = this.$store.state.currentCompany;
      this.loading = true;
      if (obj) {
        const { cpage, pagesize } = obj;
        this.options = { ...this.options, ...obj };
      }
      const res = await getStaffMsgList({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        org_level_uuid: currentCompany,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      });
      if (res.code === "200") {
        this.desserts = res.data;
        // this.$set(this.options, 'totalcount', res.totalcount)
        // this.$set(this.options, 'totalpage', res.totalpage)
        this.options.totalcount = res.totalcount;
        this.options.totalpage = res.totalpage;
        this.systemFieldMeta = res.systemFieldMeta;
        this.field_alias_name = res.field_alias_name;
        this.table_alias_name = res.table_alias_name;
      }
      this.loading = false;
    },
    godetail(item) {
      this.$store.commit("set_iconstatus", true); //行内进图标显示
      this.$store.commit(
        "set_subPage_name",
        (item.christian_name ? item.christian_name : "") + item.show_name
      );
      this.$store.commit("set_uuid", item.uuid); //
      this.$store.commit("set_detailuuid", item.user_id); //暂用用客户详情的detailuuid,暂时无bug
      this.$router.push({
        name: "detailstaffmanagement",
      });
    },

    handleClick({ item }, obj) {
      switch (item.type) {
        case "view":
          this.godetail(obj);
          break;
        case "edit":
          this.$store.commit("set_iconstatus", false); //行内进图标显示
          this.$store.commit(
            "set_subPage_name",
            (obj.christian_name ? obj.christian_name : "") + obj.show_name
          );
          this.$store.commit("set_uuid", obj.uuid); //
          this.$store.commit("set_detailuuid", obj.user_id);
          this.$router.push({
            name: "detailstaffmanagement",
          });
          break;
        case "edit-pw":
          this.$refs.changePassword.active(obj);
          break;
        case "reset":
          this.$myConfirm({
            content: this.$t("message_Confirm_that_the_password_is_reset"),
          }).then((res) => {
            resetPassWord({ user_account: obj.user_account }).then((res) => {
              if (res.code == 200) {
                this.$Message({
                  text: this.$t("message_The_operation_was_successful"),
                });
                this.getlist();
              }
            });
          });
          break;
        case "freeze":
          this.$myConfirm({
            content: this.$t("message_Confirm_that_the_account_is_frozen"),
          }).then((res) => {
            freezeStaff({ uuid: obj.uuid }).then((res) => {
              if (res.code == 200) {
                this.$Message({
                  text: this.$t("message_The_operation_was_successful"),
                });
                this.getlist();
              }
            });
          });
          break;
        case "resumePost":
          resumePost({ uuid: obj.uuid }).then((res) => {
            if (res.code == 200) {
              this.$Message({
                text: this.$t("message_The_operation_was_successful"),
              });
              this.getlist();
            }
          });
          break;
      }
    },
  },
  computed: {
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-staff-management"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-staff-management"),
          type: "edit",
        },
        {
          name: this.$t("label_To_edit_your_password"),
          show: this.hasBtn("edit-staff-password"),
          type: "edit-pw",
        },
        {
          name: this.$t("label_To_reset_your_password"),
          show: this.hasBtn("reset-staff-password"),
          type: "reset",
        },
        {
          name: this.$t("label_Frozen_account"),
          show: this.hasBtn("edit-staff-status"),
          type: "freeze",
        },
        {
          name: this.$t("label_staffMsg_m_resumePost"),
          show: this.hasBtn("resume-post"),
          type: "resumePost",
        },
      ];
    },
    headers() {
      return [
        {
          // text:
          //   this.$t("label_Employee_name") +
          //   "、" +
          //   this.$t("label_position_office") +
          //   "、" +
          //   this.$t("label_company") +
          //   this.$t("label_and") +
          //   this.$t("label_department"),
          text: this.$t("label_staff_m_name"),
          align: "start",
          value: "name",
          sortable: false,
        },
        {
          text: this.$t("label_account"),
          value: "user_account",
          sortable: false,
        },
        {
          text: this.$t("label_department"),
          value: "dept_uuid",
          sortable: false,
        },
        // {
        //   text: this.$t("label_Position_Title"),
        //   value: "position",
        //   sortable: false,
        // },

        {
          text: this.$t("label_employment_status"),
          value: "staff_status",
          sortable: false,
        },
        {
          // text: this.$t('label_state'),
          text: this.$t("label_account_status"),
          value: "STATUS",
          sortable: false,
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "end",
        },
      ];
    },
  },
  watch: {
    $route(v) {
      if (v.name == "staffmanagement") {
        this.getlist();
      }
    },
  },
};
</script>

<style scoped>
.sps1 {
  display: block;
  font-size: 16px;
}

.sps2 {
  display: block;
  color: #cccccc;
  /* word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; */
}

.sps2 span:nth-child(1) {
  margin-right: 10px;
}

.sps2 span {
  max-width: 30vw;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
